var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-radio',{key:_vm.answerBlockData.ID,attrs:{"options":_vm.answerBlockData.options,"label":_vm.getCorrectLabel(),"optional":!_vm.answerBlockData.is_required,"rules":_vm.rules},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }